/**
 * Сжатие изображений перед загрузкой
 */

/**
 * Сжать изображение до указанного размера
 * @param {File} file - Исходный файл изображения
 * @param {Object} options - Опции сжатия
 * @returns {Promise<File>} - Сжатое изображение
 */
export async function compressImage(file, options = {}) {
	const {
		maxWidth = 1920,
		maxHeight = 1080,
		quality = 0.85,
		maxSizeMB = 1,
	} = options

	return new Promise((resolve, reject) => {
		const reader = new FileReader()

		reader.onload = e => {
			const img = new Image()

			img.onload = () => {
				const canvas = document.createElement('canvas')
				let { width, height } = img

				// Пропорциональное уменьшение
				if (width > maxWidth || height > maxHeight) {
					const ratio = Math.min(maxWidth / width, maxHeight / height)
					width = Math.floor(width * ratio)
					height = Math.floor(height * ratio)
				}

				canvas.width = width
				canvas.height = height

				const ctx = canvas.getContext('2d')
				ctx.drawImage(img, 0, 0, width, height)

				// Конвертация в Blob
				canvas.toBlob(
					blob => {
						if (!blob) {
							reject(new Error('Ошибка сжатия изображения'))
							return
						}

						// Проверка размера
						const sizeMB = blob.size / 1024 / 1024

						if (sizeMB > maxSizeMB && quality > 0.1) {
							// Рекурсивное сжатие с меньшим качеством
							compressImage(file, {
								...options,
								quality: quality - 0.1,
							})
								.then(resolve)
								.catch(reject)
							return
						}

						// Создание нового File объекта
						const compressedFile = new File([blob], file.name, {
							type: 'image/jpeg',
							lastModified: Date.now(),
						})

						resolve(compressedFile)
					},
					'image/jpeg',
					quality
				)
			}

			img.onerror = () => reject(new Error('Ошибка загрузки изображения'))
			img.src = e.target.result
		}

		reader.onerror = () => reject(new Error('Ошибка чтения файла'))
		reader.readAsDataURL(file)
	})
}

/**
 * Проверить, нужно ли сжимать изображение
 */
export function shouldCompress(file, maxSizeMB = 1) {
	const sizeMB = file.size / 1024 / 1024
	return sizeMB > maxSizeMB
}
